export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/account-settings/resources/mounted.js